module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalClasses = []\nconst fieldConfig = model.config || {}\nconst textFieldConfig = (fieldConfig.fields || {}).text || {}\nconst textFieldModel = {\n...model,\nconfig: textFieldConfig,\n}\n%><div class=\"<%- additionalClasses.join(' ') %>\">\n<%- include('./text', { model: textFieldModel, formMapping, config })%>\n<div class=\"controls\"><%\nfor(const buttonFormMapping of model.buttons || []){\n%><%- include('../elements/buttons/default', { formMapping: buttonFormMapping }); %><%\n}\n%></div>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\textAndButtons.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalClasses = []
const fieldConfig = model.config || {}
const textFieldConfig = (fieldConfig.fields || {}).text || {}
const textFieldModel = {
...model,
config: textFieldConfig,
}

    ; __line = 9
    ; __append("<div class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\">\n")
    ; __line = 10
    ; __append( include('./text', { model: textFieldModel, formMapping, config }))
    ; __append("\n<div class=\"controls\">")
    ; __line = 11
    ; 
for(const buttonFormMapping of model.buttons || []){

    ; __line = 13
    ; __append( include('../elements/buttons/default', { formMapping: buttonFormMapping }) )
    ; 
}

    ; __line = 15
    ; __append("</div>\n</div>")
    ; __line = 16
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\textAndButtons.ejs

}